var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-col mb-2 sm:mb-0 gap-6 w-full" },
    [
      _c("ContractorHeader", {
        attrs: {
          contractorUser: _vm.contractorUser,
          contractorFullName: _vm.contractorFullName,
          country: _vm.contractorUser.profile.country,
          state: _vm.contractorUser.profile.state,
          city: _vm.contractorUser.profile.city,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "chip",
              fn: function () {
                return [
                  _c("StatusChip", {
                    staticClass: "mr-2",
                    attrs: { status: _vm.status },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "optionalInfo",
              fn: function () {
                return [
                  _vm._t("optionalInfo"),
                  _c(
                    "div",
                    { staticClass: "flex flex-row justify-end" },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "mx-2.5 w-6 h-6 flex items-center justify-center cursor-pointer",
                          class:
                            _vm.isAdmin || _vm.hasAllResourceAccess
                              ? `actionButtonAdmin`
                              : !_vm.isContractorRequested
                              ? `actionButtonManager`
                              : `actionButtonManagerRequested`,
                          on: {
                            click: function ($event) {
                              return _vm.handleCopy(_vm.contractorUser.id)
                            },
                          },
                        },
                        [
                          _c(
                            "Tooltip",
                            {
                              staticClass: "flex items-center ml-1",
                              attrs: {
                                variant: _vm.TooltipVariants.DARK,
                                title: "Copy Profile Link",
                                tooltipClasses: "contrcAligment",
                                placement: "top",
                                arraowClass: "hideArrow",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "p-1 hoverBack -ml-7",
                                  on: {
                                    mouseover: function ($event) {
                                      _vm.isHoveredCopy = true
                                    },
                                    mouseout: function ($event) {
                                      _vm.isHoveredCopy = false
                                    },
                                  },
                                },
                                [
                                  !_vm.isHoveredCopy
                                    ? _c("CopyLink")
                                    : _vm._e(),
                                  _vm.isHoveredCopy
                                    ? _c("CopyLinkHover")
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "button",
                        {
                          class:
                            _vm.isAdmin || _vm.hasAllResourceAccess
                              ? `customMessageAdmin`
                              : !_vm.isContractorRequested
                              ? `customMessageManager`
                              : `customMessageManagerRequested`,
                          on: {
                            click: _vm.message,
                            mouseover: function ($event) {
                              _vm.isHoveredChat = true
                            },
                            mouseout: function ($event) {
                              _vm.isHoveredChat = false
                            },
                          },
                        },
                        [
                          !_vm.isHoveredChat
                            ? _c("MessageIcon", { staticClass: "w-4 h-4" })
                            : _vm._e(),
                          _vm.isHoveredChat
                            ? _c("MessageIconHover", { staticClass: "w-4 h-4" })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._t("actionButton"),
                    ],
                    2
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "userInfo",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "mb-7 flex mt-1 flex-row flex-wrap items-center",
                    },
                    [
                      !!_vm.getOccupation
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "text-lg leading-normal text-primary-black pr-1",
                            },
                            [
                              _vm._v(" " + _vm._s(_vm.getOccupation) + " "),
                              _vm.getCompany
                                ? _c("span", [
                                    _vm._v("at " + _vm._s(_vm.getCompany)),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm.getJobType
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "text-lg leading-normal text-primary-black pr-1 pl-1 flex items-center",
                            },
                            [
                              _vm.getOccupation ? _c("DotIcon") : _vm._e(),
                              _c(
                                "span",
                                {
                                  staticClass: "lowercase",
                                  class: _vm.getOccupation && `pl-1`,
                                },
                                [_vm._v(_vm._s(_vm.getJobType))]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "icons",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "flex flex-col lg:flex-row gap-8" },
                    [
                      _c("div", [
                        _c("div", { staticClass: "flex flex-row" }, [
                          _c(
                            "p",
                            {
                              staticClass:
                                "flex font-400 customlineH text-sm mb-1 text-storm-gray w-24",
                            },
                            [_vm._v(" Location: ")]
                          ),
                          _vm.location !== null
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "font-normal text-sm maxContentWidth text-badgeBlue hover:text-badgeBlue no-underline customLineH",
                                },
                                [_vm._v(" " + _vm._s(_vm.location) + " ")]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "font-normal text-sm text-primary-black customlineH",
                                },
                                [_vm._v(" n/a ")]
                              ),
                        ]),
                        _c("div", { staticClass: "flex flex-row" }, [
                          _c(
                            "p",
                            {
                              staticClass:
                                "flex font-400 customlineH text-sm mb-1 text-storm-gray w-24",
                            },
                            [_vm._v(" Website: ")]
                          ),
                          _vm.website !== null
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "text-badgeBlue block hover:text-badgeBlue text-sm maxContentWidth truncate font-normal no-underline customLineH",
                                  attrs: {
                                    href: _vm.website,
                                    target: "”_blank”",
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.website) + " ")]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "font-normal text-sm text-primary-black customlineH",
                                },
                                [_vm._v(" n/a ")]
                              ),
                        ]),
                      ]),
                      _c(
                        "div",
                        [
                          _vm.addedById !== 0
                            ? _c("PageHeadIcon", {
                                attrs: {
                                  content: _vm.fullName,
                                  title: "Added By:",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "moreDetails",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "p-2 pb-1 bg-snow-white flex flex-col md:flex-row items-center justify-center w-auto border-transparent rounded-lg",
                    },
                    [
                      _c("PageInfo", {
                        attrs: { title: "Rate", content: _vm.contractorRates },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "actions",
              fn: function () {
                return [_vm._t("actions")]
              },
              proxy: true,
            },
            {
              key: "document",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "flex flex-col gap-4 items-start" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "bg-white rounded-lg shadow-md h-64 document-sec",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "border-b border-gray-200 px-8 pt-4 pb-3.5",
                            },
                            [
                              _c("nav", { staticClass: "-mb-px flex" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "whitespace-no-wrap pb-1 border-b-2 border-secondary-black font-normal text-lg leading-5 focus:outline-none text-primary-black focus:text-gray-700 focus:border-gray-300 hover:text-gray-700 hover:border-secondary-black",
                                    attrs: { href: "#" },
                                  },
                                  [_vm._v(" Resume ")]
                                ),
                              ]),
                            ]
                          ),
                          !_vm.contractorUser.profile.resume
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center justify-center",
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-md my-20 text-primary-black text-center",
                                    },
                                    [_vm._v(" Resume not provided ")]
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "mb-4 px-4 mt-4 overflow-x-scroll customScrollDoc",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-col h-auto overflow-x-scroll p-2",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-grow overflow-auto scrollbar",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "relative w-full text-sm text-bold text-left dark:text-gray-400",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-black hover:bg-gray-50 dark:hover:bg-gray-600 flex flex-row gap-4 p-2 mb-2 bg-snow-white sm:rounded-lg",
                                                },
                                                [
                                                  _c("div", [
                                                    _c(
                                                      "svg",
                                                      {
                                                        attrs: {
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg",
                                                          width: "32",
                                                          height: "32",
                                                          viewBox: "0 0 22 22",
                                                          fill: "none",
                                                        },
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M8.44201 9.30791H9.30796C9.53762 9.30791 9.75787 9.21667 9.92027 9.05428C10.0827 8.89188 10.1739 8.67163 10.1739 8.44197C10.1739 8.2123 10.0827 7.99205 9.92027 7.82965C9.75787 7.66726 9.53762 7.57602 9.30796 7.57602H8.44201C8.21235 7.57602 7.9921 7.66726 7.8297 7.82965C7.66731 7.99205 7.57607 8.2123 7.57607 8.44197C7.57607 8.67163 7.66731 8.89188 7.8297 9.05428C7.9921 9.21667 8.21235 9.30791 8.44201 9.30791ZM8.44201 11.0398C8.21235 11.0398 7.9921 11.131 7.8297 11.2934C7.66731 11.4558 7.57607 11.6761 7.57607 11.9057C7.57607 12.1354 7.66731 12.3557 7.8297 12.518C7.9921 12.6804 8.21235 12.7717 8.44201 12.7717H13.6377C13.8673 12.7717 14.0876 12.6804 14.25 12.518C14.4124 12.3557 14.5036 12.1354 14.5036 11.9057C14.5036 11.6761 14.4124 11.4558 14.25 11.2934C14.0876 11.131 13.8673 11.0398 13.6377 11.0398H8.44201ZM17.9674 8.39001C17.9584 8.31046 17.9409 8.23209 17.9154 8.1562V8.07827C17.8738 7.98923 17.8182 7.90739 17.7509 7.83581L12.5552 2.64015C12.4837 2.5728 12.4018 2.51726 12.3128 2.47562C12.2869 2.47195 12.2607 2.47195 12.2348 2.47562C12.1469 2.42518 12.0497 2.39279 11.9491 2.38037H6.71013C6.02114 2.38037 5.36038 2.65407 4.87319 3.14126C4.386 3.62844 4.1123 4.28921 4.1123 4.9782V17.1014C4.1123 17.7904 4.386 18.4511 4.87319 18.9383C5.36038 19.4255 6.02114 19.6992 6.71013 19.6992H15.3696C16.0585 19.6992 16.7193 19.4255 17.2065 18.9383C17.6937 18.4511 17.9674 17.7904 17.9674 17.1014V8.44197C17.9674 8.44197 17.9674 8.44196 17.9674 8.39001ZM12.7717 5.33323L15.0145 7.57602H13.6377C13.408 7.57602 13.1877 7.48479 13.0254 7.32239C12.863 7.16 12.7717 6.93974 12.7717 6.71008V5.33323ZM16.2355 17.1014C16.2355 17.331 16.1443 17.5513 15.9819 17.7137C15.8195 17.8761 15.5992 17.9673 15.3696 17.9673H6.71013C6.48047 17.9673 6.26021 17.8761 6.09782 17.7137C5.93542 17.5513 5.84419 17.331 5.84419 17.1014V4.9782C5.84419 4.74853 5.93542 4.52828 6.09782 4.36588C6.26021 4.20349 6.48047 4.11226 6.71013 4.11226H11.0398V6.71008C11.0398 7.39907 11.3135 8.05983 11.8007 8.54702C12.2879 9.03421 12.9487 9.30791 13.6377 9.30791H16.2355V17.1014ZM13.6377 14.5036H8.44201C8.21235 14.5036 7.9921 14.5948 7.8297 14.7572C7.66731 14.9196 7.57607 15.1398 7.57607 15.3695C7.57607 15.5992 7.66731 15.8194 7.8297 15.9818C7.9921 16.1442 8.21235 16.2354 8.44201 16.2354H13.6377C13.8673 16.2354 14.0876 16.1442 14.25 15.9818C14.4124 15.8194 14.5036 15.5992 14.5036 15.3695C14.5036 15.1398 14.4124 14.9196 14.25 14.7572C14.0876 14.5948 13.8673 14.5036 13.6377 14.5036Z",
                                                            fill: "#1890FF",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex-col",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fileNameRow",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm
                                                                  .contractorUser
                                                                  .profile
                                                                  .resume
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-auto flex justify-center items-center",
                                                    },
                                                    [
                                                      _c(
                                                        "Processing",
                                                        {
                                                          attrs: {
                                                            processing:
                                                              _vm.processing,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex w-full items-center",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "mr-1 cursor-pointer flex",
                                                                  on: {
                                                                    click:
                                                                      _vm.downloadFile,
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "svg",
                                                                    {
                                                                      attrs: {
                                                                        width:
                                                                          "14",
                                                                        height:
                                                                          "15",
                                                                        viewBox:
                                                                          "0 0 14 15",
                                                                        fill: "none",
                                                                        xmlns:
                                                                          "http://www.w3.org/2000/svg",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              d: "M6.90156 9.8252C6.91326 9.84014 6.92819 9.85222 6.94525 9.86053C6.96231 9.86884 6.98103 9.87316 7 9.87316C7.01897 9.87316 7.03769 9.86884 7.05475 9.86053C7.0718 9.85222 7.08674 9.84014 7.09844 9.8252L8.84844 7.61113C8.9125 7.52988 8.85469 7.40957 8.75 7.40957H7.59219V2.12207C7.59219 2.05332 7.53594 1.99707 7.46719 1.99707H6.52969C6.46094 1.99707 6.40469 2.05332 6.40469 2.12207V7.40801H5.25C5.14531 7.40801 5.0875 7.52832 5.15156 7.60957L6.90156 9.8252ZM12.7188 9.27832H11.7812C11.7125 9.27832 11.6562 9.33457 11.6562 9.40332V11.8096H2.34375V9.40332C2.34375 9.33457 2.2875 9.27832 2.21875 9.27832H1.28125C1.2125 9.27832 1.15625 9.33457 1.15625 9.40332V12.4971C1.15625 12.7736 1.37969 12.9971 1.65625 12.9971H12.3438C12.6203 12.9971 12.8438 12.7736 12.8438 12.4971V9.40332C12.8438 9.33457 12.7875 9.27832 12.7188 9.27832Z",
                                                                              fill: "#717986",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                        ]
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "div",
        [
          _vm._m(0),
          _c("ContractorDetailedInformation", {
            attrs: {
              certifications: _vm.contractorUser.certifications,
              educations: _vm.contractorUser.educations,
              experiences: _vm.contractorUser.experiences,
              profile: _vm.contractorUser.profile,
              isAccessGranted: _vm.isAccessGranted,
              contractorUserId: _vm.contractorUser.id,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "capitalize bg-white routeBlock" }, [
      _c("div", { staticClass: "border-b border-gray-200 px-8 pt-4 pb-3.5" }, [
        _c("nav", { staticClass: "-mb-px flex" }, [
          _c(
            "a",
            {
              staticClass:
                "whitespace-no-wrap pb-1 border-b-2 border-transparent border-secondary-black font-normal text-lg leading-5 focus:outline-none text-primary-black focus:text-gray-700 focus:border-gray-300 hover:text-gray-700 hover:border-secondary-black",
              attrs: { href: "#" },
            },
            [_vm._v(" About ")]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }